<template>
    <div>
        <escenario-opcion-componente nombre="Uso"
                                     descripcion="Dependiendo del uso, se asignarán diferentes frecuencias de mantenimiento.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        campo-descripcion="explicacion"
                        :opciones="usos"
                        propiedad="uso"
                        descripcion="Seleccionar uso"
                        @change="seleccionarUso">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Ubicación de la partición vertical" descripcion="Especifica si la partición es un tabique dentro de una vivienda o bien es un tabique entre viviendas.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        campo-descripcion="explicacion"
                        :opciones="ubicaciones"
                        propiedad="ubicacion"
                        descripcion="Seleccionar ubicacion"
                        @change="seleccionarUbicacion">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Tipo de soporte" descripcion="Hace referencia a la estructura del tabique.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        campo-descripcion="explicacion"
                        :opciones="tiposSoporte"
                        propiedad="tipoSoporte"
                        descripcion="Seleccionar tipo soporte"
                        @change="seleccionarTipoSoporte">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Modalidad del soporte" descripcion="Especifica si la partición es un tabique que divide una misma unidad de uso o dos unidades de uso diferentes">
            <template v-slot:seleccion>
                <div class="font-italic font-weight-bold pa-2 caption" v-if="escenario && escenario.ubicacion == null">
                    Se debe seleccionar la ubicación antes
                </div>
                <escenario-seleccion-componente
                        v-if="escenario && escenario.ubicacion != null"
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        campo-descripcion="explicacion"
                        :opciones="tiposModalidadSoporteSeleccion"
                        propiedad="tipoModalidadSoporte"
                        descripcion="Seleccionar modalidad soporte"
                        @change="seleccionarModalidadSoporte">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Revestimiento cara Opuesta" descripcion="Identifica el acabado de la cara opuesta de la partición.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        :opciones="carasOpuesta"
                        propiedad="caraOpuesta"
                        descripcion="Seleccionar cara opuesta"
                        @change="seleccionarCaraOpuesta">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Necesidades especiales de higiene" descripcion="Puede aplicarse a cualquiera de los usos y repercute en los indicadores prestacionales (resitencia a las manchas y química).">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        :opciones="higienes"
                        propiedad="necesidadHigiene"
                        descripcion="Seleccionar necesidad higiene"
                        @change="seleccionarNecesidadHigiene">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>
    </div>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import EscenarioOpcionComponente from "./Componentes/EscenarioOpcionComponente";
    import EscenarioSeleccionComponente from "./Componentes/EscenarioSeleccionComponente";

    export default {
        name: "EscenarioVertical",
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            escenario: {type: Object, required: true},
            correcto: {type: Boolean, default: false}
        },
        components: {
            EscenarioOpcionComponente,
            EscenarioSeleccionComponente
        },
        data: function () {
            return {
                usos: [],
                ubicaciones: [],
                tiposSoporte: [],
                tiposModalidadSoporte: [],
                tiposModalidadSoporteActivados: [],
                tiposModalidadSoporteSeleccion: [],
                carasOpuesta: [],
                higienes: [],
            }
        },
        mounted() {
            Promise.all([
                this.obtenerUsos(),
                this.obtenerUbicaciones(),
                this.obtenerTiposSoporte(),
                this.obtenerModalidadesSoporte(),
                this.obtenerNecesidadesHigiene(),
                this.obtenerCarasOpuesta(),
            ]).then(() => {
                this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
            });
        },
        watch: {
            escenario: {
                handler(val) {
                    this.emitirCorrecto(this.escenarioEsCorrecto(val));
                },
                deep: true
            }
        },
        methods: {
            obtenerUsos() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/vertical/uso")
                        .then(data => {
                            this.usos = data;
                            resolve();
                        });
                });
            },
            obtenerUbicaciones() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/vertical/ubicacion").then(data => {
                        this.ubicaciones = data;
                        resolve();
                    });
                });
            },
            obtenerTiposSoporte() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/vertical/tipo-soporte")
                        .then(data => {
                            this.tiposSoporte = data;
                            resolve();
                        });
                });

            },
            obtenerModalidadesSoporte() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/vertical/tipo-modalidad-soporte")
                        .then(data => {
                            this.tiposModalidadSoporte = data;
                            resolve();
                            this.obtenerModalidadesSoporteActivadas();
                        });
                });
            },
            obtenerModalidadesSoporteActivadas() {
                return new Promise(resolve => {
                    this.tiposModalidadSoporteActivados = [];

                    if (!this.escenario || (this.escenario && this.escenario.ubicacion == null)) resolve();
                    HttpHelper.get("obra-nueva/vertical/tipo-modalidad-soporte/por-ubicacion/"
                        + this.escenario.ubicacion.codigo)
                        .then(data => {
                            data.forEach((type) => {
                                this.tiposModalidadSoporteActivados.push(type.codigo)
                            });
                            this.tiposModalidadSoporteSeleccion = [];
                            this.tiposModalidadSoporte.forEach((fm) => {
                                if (this.tiposModalidadSoporteActivados.includes(fm.codigo)) {
                                    this.tiposModalidadSoporteSeleccion.push(fm);
                                }
                            });
                            if (this.escenario.tipoModalidadSoporte != null &&
                                !this.tiposModalidadSoporteActivados.includes(this.escenario.tipoModalidadSoporte.codigo))
                                this.escenario.tipoModalidadSoporte = null;

                            resolve();
                            this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
                        });
                });
            },
            obtenerNecesidadesHigiene() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/vertical/necesidad-higiene")
                        .then(data => {
                            this.higienes = data;
                            resolve();
                        });
                });
            },
            obtenerCarasOpuesta() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/vertical/cara-opuesta")
                        .then(data => {
                            this.carasOpuesta = data;
                            resolve();
                        });
                });
            },
            seleccionarUso(item) {
                this.escenario.uso = item;
            },
            seleccionarUbicacion(item) {
                this.escenario.ubicacion = item;
                this.obtenerModalidadesSoporteActivadas();
            },
            seleccionarTipoSoporte(item) {
                this.escenario.tipoSoporte = item;
            },
            seleccionarModalidadSoporte(item) {
                if (!this.tiposModalidadSoporteActivados.includes(item.codigo)) return;

                this.escenario.tipoModalidadSoporte = item;
            },
            seleccionarCaraOpuesta(item) {
                this.escenario.caraOpuesta = item;
            },
            seleccionarNecesidadHigiene(item) {
                this.escenario.necesidadHigiene = item;
            },
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            escenarioEsCorrecto(escenario) {
                let params = [
                    escenario.ubicacion,
                    escenario.tipoSoporte,
                    escenario.tipoModalidadSoporte,
                    escenario.necesidadHigiene,
                    escenario.caraOpuesta,
                    escenario.uso
                ];

                let someNull = false;
                params.forEach((item) => {
                    if (item == null) someNull = true;
                });
                if (someNull) return false;

                if (!escenario.tipoModalidadSoporte ||
                    !this.tiposModalidadSoporteActivados.includes(escenario.tipoModalidadSoporte.codigo))
                    return false;

                return true;
            },
        }
    }
</script>

<style scoped>
</style>